export enum UserLocalStorageKeys {
  // No longer written since CONF-02 phase 4 (search served by the backend);
  // kept so logout and the search hook can still purge old values.
  AlgoliaConfig = 'algolia-config-{id}',
  ThreadDrafts = 'thread-draft-{id}',
  SidebarWidth = 'sidebar-width',
  DefaultOrgId = 'default-org-id',
  OnboardingTodoCollapsed = 'onboarding-todo-collapsed-{id}',
  OrgLifecycleTracked = 'org-lifecycle-{id}',
}

export function resetUserLocalStorage() {
  for (const key in localStorage) {
    for (const keyPattern of Object.values(UserLocalStorageKeys)) {
      if (
        new RegExp('^' + keyPattern.replace(/\{id\}/, '.*') + '$').test(key)
      ) {
        localStorage.removeItem(key)
      }
    }
  }
}
